// var propriedades = ["numTurmas", "numAlunosTurmas", "cargaHoraria", "numMatriculasResiduais", "numMatriculasNovas", "numTotalMatriculas", "horaAluno", "horaAlunoDistribuida", "cargaHorariaTurmaAno", "necessidadeDocente8H", "necessidadeDocente7H"]
var propriedades = ["numTurmas", "numMatriculasResiduais", "numMatriculasNovas", "numTotalMatriculas", "horaAluno", "horaAlunoDistribuida", "horaAlunoDistribuidaPercentualEvasao"]

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
        acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

function total(metas, mes=undefined) {
    let unidade;
    let total = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    (metas[unidade] || metas).map((valor) => {
        valor.metasMensais.forEach((meta) => {
            propriedades.forEach((prop, i) => {
                if(mes !== undefined) {
                    if(meta.mes === mes) {
                        total[i] += meta[prop];
                    }
                } else {
                    total[i] += meta[prop];
                }
            });
        });
    });
    return total;
}

// Se o valor do filtro for um array (filtro multi-select), casa por
// pertencimento (OR entre os valores escolhidos); se for um valor único,
// continua comparando por igualdade — retrocompatível com todo consumidor
// existente (Dashboard/index.js, Dashboard/index_v2.js, Dashboard/V2/calculo.js,
// STI/Dashboard/Portfolio), que sempre passa string, nunca array.
function filtrar(metas, filtros) {
    for (const key in filtros) {
        let valor = filtros[key];
        if (Array.isArray(valor)) {
            metas = metas.filter(meta => valor.includes(meta[key]));
        } else {
            metas = metas.filter(meta => meta[key] === valor);
        }
    }
    return metas;
}

function retornaJsonTotalModalidadesTipo(modalidades, filtros, mes, metas) {
    let totalModalidadesTipo = {}
    modalidades.forEach(modalidade => {
        filtros.modalidade = modalidade
        let pagos = filtrar(metas, filtros);
        totalModalidadesTipo[modalidade] = total(pagos, mes);
    });
    return totalModalidadesTipo
}

module.exports = { 
    groupBy, 
    total,
    filtrar,
    retornaJsonTotalModalidadesTipo
};